import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Renderizza il Markdown delle risposte AI con stile coerente al tema.
export const MarkdownMessage = ({ content }) => (
  <div className="text-sm leading-relaxed space-y-2 [&_p]:m-0" data-testid="markdown-content">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ node, ...p }) => <h3 className="text-base font-semibold mt-2 mb-1" {...p} />,
        h2: ({ node, ...p }) => <h3 className="text-sm font-semibold mt-2 mb-1" {...p} />,
        h3: ({ node, ...p }) => <h4 className="text-sm font-semibold mt-2 mb-1" {...p} />,
        p: ({ node, ...p }) => <p className="mb-2 last:mb-0" {...p} />,
        strong: ({ node, ...p }) => <strong className="font-semibold text-foreground" {...p} />,
        ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1 my-1" {...p} />,
        ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1 my-1" {...p} />,
        li: ({ node, ...p }) => <li className="marker:text-muted-foreground" {...p} />,
        code: ({ node, inline, ...p }) =>
          inline
            ? <code className="px-1 py-0.5 rounded bg-background/60 text-[0.85em] font-mono" {...p} />
            : <code className="block p-2 rounded-md bg-background/60 text-[0.85em] font-mono overflow-x-auto" {...p} />,
        table: ({ node, ...p }) => <div className="overflow-x-auto my-2"><table className="w-full text-xs border-collapse" {...p} /></div>,
        th: ({ node, ...p }) => <th className="border-b border-border px-2 py-1 text-left font-semibold" {...p} />,
        td: ({ node, ...p }) => <td className="border-b border-border/50 px-2 py-1 tabular-nums" {...p} />,
        a: ({ node, ...p }) => <a className="text-primary underline underline-offset-2" {...p} />,
      }}
    >
      {content || ''}
    </ReactMarkdown>
  </div>
);
